export const LOADING = "LOADING";

export const loadingRequest = loading => ({
    type: LOADING,
    payload: loading
})